import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CAMPAIGNS_OBJECT_TYPE_ID } from 'universal-associations-select/hooks/useFetchHasCampaigns';
import CampaignsEmptyState from 'universal-associations-select/components/CampaignsEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyState = ({
  isSearching,
  selectedObjectTypeId,
  refetchOptions,
  engagementOrInteractionType,
  apiClient
}) => {
  if (isSearching) {
    return /*#__PURE__*/_jsx(ResultsMessage, {
      marginBlockStart: "200",
      marginBlockEnd: "0",
      illustration: "empty-state-charts",
      illustrationProps: {
        width: 130,
        marginBlockEnd: '400'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "universalAssociationsSelect.noResultsFound"
      })
    });
  }
  if (selectedObjectTypeId === CAMPAIGNS_OBJECT_TYPE_ID) {
    return /*#__PURE__*/_jsx(CampaignsEmptyState, {
      refetchOptions: refetchOptions,
      engagementOrInteractionType: engagementOrInteractionType,
      apiClient: apiClient
    });
  }
  return /*#__PURE__*/_jsxs(ResultsMessage, {
    marginBlockStart: "200",
    marginBlockEnd: "0",
    illustration: "empty-state-charts",
    illustrationProps: {
      width: 130,
      marginBlockEnd: '400'
    },
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: selectedObjectTypeId ? 'universalAssociationsSelect.searchResults.noResults.noRecordsFound' : 'universalAssociationsSelect.searchResults.noResults.noCurrentAssociations'
    }), /*#__PURE__*/_jsx("br", {}), selectedObjectTypeId ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "universalAssociationsSelect.searchResults.noResults.searchToFind"
    }) : null]
  });
};
export default EmptyState;